import cn from 'classnames'
import React from 'react'

import type { IFieldLayoutProps } from 'components/formKit/types'
import { Tooltip } from 'components/uiKit/Dropdown'
import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'
import { Typography } from 'components/uiKit/Typography'

import * as s from './FieldBaseLabel.module.scss'

const FieldBaseLabel: React.FC<Omit<IFieldLayoutProps, 'children'>> = ({
  label,
  required,
  info,
  layout = 'horizontal',
  size = KitSize.M,
  layoutModifiers,
}) => {
  if (!label) {
    return null
  }

  return (
    <label
      className={cn(
        s.root,
        s[layout],
        s[size],
        layoutModifiers?.map((item) => s[item]),
        { [s.required]: required },
      )}
    >
      <Typography styleType='hint'>{label}</Typography>
      {info && (
        <Tooltip overlay={info}>
          <Icon name='builderTooltip' size={size} />
        </Tooltip>
      )}
    </label>
  )
}

export default React.memo(FieldBaseLabel) as typeof FieldBaseLabel
